// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/pixel-art-splash.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styling for Digital Art page */

#pixel-art-iframe {
    width: 100%;
    height: 85vh;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: auto 100%;
    background-position: center;
}`, "",{"version":3,"sources":["webpack://./src/css/DigitalArtPage.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;IACI,WAAW;IACX,YAAY;IACZ,yDAAqD;IACrD,4BAA4B;IAC5B,0BAA0B;IAC1B,2BAA2B;AAC/B","sourcesContent":["/* Styling for Digital Art page */\n\n#pixel-art-iframe {\n    width: 100%;\n    height: 85vh;\n    background-image: url(../images/pixel-art-splash.svg);\n    background-repeat: no-repeat;\n    background-size: auto 100%;\n    background-position: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
